import PracQuizTableData from './PracQuizTableData';

export default PracQuizTableData;
